import axios from "axios";
import { useEffect, useState } from "react";

import {
  EXPANDED_FOOTER_URL,
  MAGNOLIA_NEXT_API_URL,
  PRODUCT,
  SECONDARY_PRODUCT,
  INT_COUNTRY,
} from "@/constants";

import { ExpandedFooterResponse } from "./types/regulatory-disclaimer-footer-types";

export function useRegulatoryDisclaimerFooter() {
  const [data, setData] = useState<ExpandedFooterResponse | null>(null);
  const [error, setError] = useState<Error | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const url = `${MAGNOLIA_NEXT_API_URL}${EXPANDED_FOOTER_URL}/${
    INT_COUNTRY ?? SECONDARY_PRODUCT ?? PRODUCT
  }`;

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;

    async function fetchData() {
      try {
        const response = await axios.get<{ data: ExpandedFooterResponse }>(
          url,
          { signal }
        );
        if (response?.data?.data) {
          const footerData = response.data.data;
          setData(footerData);
        }
        setError(null);
      } catch (err) {
        if (axios.isCancel(err)) {
          return;
        }
        setError(err as Error);
        setData(null);
      } finally {
        setLoading(false);
      }
    }

    fetchData();

    return () => {
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { data, error, loading };
}
